import { useState } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { Spin, Typography } from 'antd';

import { getBook } from '../../../service/book';
import { useUserStore } from '../../../store/useUser';
import { getBooksGenres } from '../../../service/genres';
import useHeader from '../../../hooks/useHeader';

import { CommentBook } from '../../../components/Comment/Comment';
import DefaultContainer from '../../../components/DefaultContainer/DefaultContainer';
import { CommentForm } from '../../../components/CommentForm/CommentForm';
import { getCommentsByBook } from '../../../service/comment';

import Button from '../../../components/Button/Button';
import Modal from '../../../components/Modal/Modal';
import AddBookToBookcaseModal from '../../../container/Modal/Modals/AddBookOnBookcase/AddBookOnBookcase';
import { BookComponent } from './options';

import styles from './Book.module.scss'
import { StateBook } from '../../../models/books';
import { addBookToClubBookcase, addBookToUserBookcase } from '../../../service/bookcase';
import { createErrorNotification, createSuccessNotification } from '../../../service/notification';
import { AddBookToBookcaseButton } from './AddBookToBookcaseButton';

const { Paragraph, Text } = Typography;

const CommentsSection = (userId: number, bookId: number) => {
  const profile = useUserStore(state => state.profile)

  const { data: comments, refetch } = useQuery(
    ['comments'],
    () => getCommentsByBook(Number(userId), Number(bookId)),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false, enabled: true },
  );

  return (
    <div>
      {profile !== 'Clubista' &&
        <DefaultContainer>Faça login como clubista pra fazer um comentário</DefaultContainer>}

      {
        profile === 'Clubista' &&
        <section className={styles.sinopse}>
          <h2><strong>Comentários</strong></h2>
          <CommentForm refetchData={refetch} userId={userId} bookId={Number(bookId)} ></CommentForm>
        </section>
      }

      <div>
        {comments?.map(comment => (
          <CommentBook
            comment={comment}
          ></CommentBook>
        ))}

        {!comments?.length && <DefaultContainer>Esse livro ainda não têm comentários</DefaultContainer>}

      </div>
    </div>
  );
}

function LocalBookInfo() {
  const [loading, setLoading] = useState(false);

  const { id: bookId} = useParams();

  const profile = useUserStore(state => state.profile)
  const club = useUserStore(state => state.club)
  const userId = useUserStore(state => state?.id);

  const { data: genres } = useQuery(
    ['genres'],
    () => getBooksGenres(Number(bookId)),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false }
  );

  const { data: book, isFetching } = useQuery(
    ['book', bookId],
    () => getBook(Number(bookId)),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false }
  );

  useHeader({ header: book?.name });

  const handleAddBookcase = async (params: {
    id: number | undefined;
    values: { state: StateBook; score: number };
  }) => {
    const { id, values } = params;
    const addBookcaseFunction = club && club.id && ['Mediador', 'Criador'].includes(profile)
      ? addBookToClubBookcase
      : addBookToUserBookcase;

    try {
      const { error, success } = await addBookcaseFunction(id, book?.id, values);
      setLoading(false);

      if (error) {
        return createErrorNotification('Erro ao adicionar na estante. Tente novamente mais tarde.');
      }

      return createSuccessNotification('Livro adicionado na estante.');
    } catch (error) {
      setLoading(false);
      return createErrorNotification('Erro ao adicionar na estante. Tente novamente mais tarde.');
    }
  };

  const addToBookcase = async (values: { state: StateBook; score: number }) => {
    if (!userId) return

    const id = (club && ['Mediador', 'Criador'].includes(profile)) ? club.id : userId

    return handleAddBookcase({ id, values });
  };

  return (
    <Spin spinning={isFetching}>
      <section className={styles.book}>
        {!!book && <BookComponent
          author={book?.author}
          imageLink={book?.imageLink}
          genres={genres}
          name={book?.name}
          page={book?.page}
          key={book.id}
        />
        }
        <Modal
          renderToggle={({ toggleModal }) => 
            <AddBookToBookcaseButton
              loading={loading}
              onClick={toggleModal}
            />
          }
        >
          {({ setOpen }) => {
            return (
              <AddBookToBookcaseModal onClick={(values) => {
                addToBookcase(values)
                setOpen(false)
              }}/>
          )}}
        </Modal>
      </section>
      <section className={styles.sinopse}>
        <h2><strong>Sinopse do livro</strong></h2>
        <Paragraph ellipsis={{ rows: 2, expandable: true, symbol: 'mais', }}>
          {book?.description || ''}
        </Paragraph>
      </section>
      {CommentsSection(userId, Number(bookId))}
    </Spin>
  )
}

export default LocalBookInfo;
